module.exports = __webpack_public_path__ + "nopayment@3x-3rKSdQH.png";